import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { TableComponent } from '@shared/components/table-component/table.component';
import { AgentPerformanceService } from '@services/agent-performance.service';
import { IAgentPerformanceResponse } from '@shared/interfaces/agent-performance.interface';
import { IColumn } from '@shared/interfaces/column.interface';
import { DATE_FILTERS } from '@shared/contants/variables';
import { PageHeaderComponent } from '@shared/components/page-header/page-header.component';
import { CardModule } from 'primeng/card';

@Component({
    selector: 'app-sale-performance',
    imports: [CommonModule, TableComponent, CardModule, PageHeaderComponent],
    standalone: true,
    templateUrl: './sale-performance.component.html',
    styleUrl: './sale-performance.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SalePerformanceComponent implements OnInit {
    revenueTemplate = viewChild('revenueTemplate');
    agentPerformanceService = inject(AgentPerformanceService);

    tableData = signal<IAgentPerformanceResponse['results'] | undefined>(undefined);
    tableLoading = signal<boolean>(false);

    cols: IColumn[] = [];
    filterDateSearch = '';
    beginDate = '';
    endDate = '';

    ngOnInit() {
        this.filterDateSearch = sessionStorage.getItem(DATE_FILTERS.FLIGHT_DATE_SEARCH) || '';
        this.beginDate = sessionStorage.getItem(DATE_FILTERS.BEGIN_DATE) || '';
        this.endDate = sessionStorage.getItem(DATE_FILTERS.END_DATE) || '';

        this.getAgentPerformance();
    }

    ngAfterViewInit() {
        setTimeout(() => this.defineColumns());
    }

    defineColumns() {
        this.cols = [
            { key: 'agentName', label: 'Agent' },
            { key: 'convRate', label: 'Conv. Rate%' },
            { key: 'revenue', label: 'Revenue', template: this.revenueTemplate() },
            { key: 'totalRequest', label: 'Total Request' },
            { key: 'performance', label: 'Performance' }
        ];
    }

    getAgentPerformance() {
        this.tableLoading.set(true);
        this.agentPerformanceService.getAgentPerformance(this.filterDateSearch, this.beginDate, this.endDate).subscribe({
            next: (response) => {
                this.tableData.set(response.results);
                this.tableLoading.set(false);
            },
            error: (error) => {
                console.error(error);
                this.tableLoading.set(false);
            }
        });
    }
}
